import { combineReducers, configureStore } from "@reduxjs/toolkit";

import breakingNews from "./features/breakingNews-slice";
import curation from "./features/curation-slice";
import liveRadio from "./features/live-radio-slice";
import modulesById from "./features/modulesById-slice";
import navMenuItems from "./features/navMenuItems-slice";
import pageData from "./features/pageData-slice";
import personalization from "./features/personalization-slice";
import serverError from "./features/serverError-slice";
import tickerBar from "./features/tickerbar-slice";
import tophatSnippet from "./features/tophat-slice";
import user from "./features/user-slice";

const USE_DEV_TOOLS = process.env.NODE_ENV !== "production";

const rootReducer = combineReducers({
    liveRadio,
    breakingNews,
    curation,
    pageData,
    /**
     * @todo: [ENG4AUD-784]remove modulesById from redux
     */
    modulesById,
    personalization,
    serverError,
    tophatSnippet,
    navMenuItems,
    tickerBar,
    user,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof configureAppStore>;
export type AppDispatch = AppStore["dispatch"];

export default function configureAppStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: rootReducer,
        devTools: USE_DEV_TOOLS,
        preloadedState,
    });
}
